/** Compact "My Requests" strip for the Services home. */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { ChevronRight, ClipboardList } from "lucide-react";
import StatusBadge from "@/components/app/StatusBadge";
import { useAuth } from "@/context/AuthContext";
import { own } from "@/lib/terminology";

function fmt(v) {
  if (!v) return "";
  try { return new Date(v).toLocaleDateString(undefined, { day: "2-digit", month: "short" }); }
  catch { return ""; }
}

export default function MyRequestsStrip() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/requests/", { params: { limit: 5 } })
      .then(({ data }) => setItems(data.items || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="st-skeleton h-24" />;
  if (items.length === 0) return null;

  return (
    <section data-testid="my-requests-strip">
      <div className="flex items-baseline justify-between mb-3">
        <h2 className="font-heading text-[15px] font-semibold text-slate-900 inline-flex items-center gap-2">
          <ClipboardList className="h-4 w-4 text-slate-500" strokeWidth={1.6} /> {own(user, "recent requests")}
        </h2>
        <Link to="/requests" className="text-[11px] text-slate-500 hover:text-slate-900" data-testid="my-requests-viewall">View all</Link>
      </div>
      <ul className="divide-y divide-slate-100 bg-white border border-slate-200 rounded-md">
        {items.map((r) => (
          <li key={r.id}>
            <Link to={`/requests`} className="flex items-center gap-3 px-4 py-3 hover:bg-slate-50" data-testid={`my-req-${r.id}`}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="font-mono text-[11px] text-slate-500">{r.request_code || r.id.slice(0, 8)}</span>
                  <span className="text-sm text-slate-800 truncate">{r.service_name || (r.request_type || "request").replace(/_/g, " ")}</span>
                </div>
                <div className="text-[11px] text-slate-500 mt-0.5">Opened {fmt(r.created_at)}</div>
              </div>
              <StatusBadge value={r.status} />
              <ChevronRight className="h-4 w-4 text-slate-400" />
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
